/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { AvailabilityDelayEnum } from './availabilityDelayEnum';
import { NullEnum } from './nullEnum';

export type TrainingServicePreferencesAvailabilityDelay =
  | (typeof TrainingServicePreferencesAvailabilityDelay)[keyof typeof TrainingServicePreferencesAvailabilityDelay]
  | null;

export const TrainingServicePreferencesAvailabilityDelay = {
  ...AvailabilityDelayEnum,
  ...NullEnum,
} as const;
